import { render, staticRenderFns } from "./qusetionnairepaper2.vue?vue&type=template&id=88569c9a&scoped=true"
import script from "./qusetionnairepaper2.vue?vue&type=script&lang=js"
export * from "./qusetionnairepaper2.vue?vue&type=script&lang=js"
import style0 from "./qusetionnairepaper2.vue?vue&type=style&index=0&id=88569c9a&prod&lang=less"
import style1 from "./qusetionnairepaper2.vue?vue&type=style&index=1&id=88569c9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88569c9a",
  null
  
)

export default component.exports